<ion-header no-border mode="md">
    <ion-toolbar color="primary" mode="md">
        <ion-title>
            {{ data?.title | translate }}
        </ion-title>
        <ion-buttons slot="end">
            <ion-button color="light" (click)="dismiss()" mode="ios">
                <ion-icon class="bp-close"></ion-icon>
            </ion-button>
        </ion-buttons>
    </ion-toolbar>
</ion-header>

<ion-content *ngIf="data?.name; else NoContent" padding class="content">
    <ion-label class="report-description ion-text-center ion-text-wrap" lines="none" color="primary">
        {{data?.name  | translate }}
    </ion-label>
    <span class="divider"></span>
    <ul class="report-content">
        <li class="report-content-item" *ngFor="let content of data?.contents">
            <ion-label color="title" *ngIf="content.title" class="content-title">{{content.title  | translate}}:</ion-label>
            <ion-label color="title" class="content-description">{{content.description  | translate}}</ion-label>
        </li>
    </ul>
</ion-content>
<ng-template #NoContent>
    <ion-content class="content ion-padding">
        <ion-label class="report-description ion-text-center ion-text-wrap" lines="none" color="primary">
            {{'Generic.noReportDescription' | translate}}
        </ion-label>
    </ion-content>
</ng-template>
